/* eslint-disable no-unused-vars */
import AccordionDetails from '@mui/material/AccordionDetails';
import * as S from './CampaignSection.styled';

const labelStyle = {
  // color: '#0F172A',
  // fontSize: '24px',
  // fontStyle: 'normal',
  // fontWeight: '500',
  // lineHeight: '32px',
};

const discStyle = {
  color: '#94A3B8',
  fontFamily: 'Roboto',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '30px',
  marginLeft: 'auto',
};

const errorBorder = {
  border: '1px solid #FCA5A5',
  boxShadow: `0px 1px 2px 0px rgba(30, 50, 70, 0.06), 0px 1px 3px 0px rgba(30, 50, 70, 0.10)`,
};

const CampaignSection = ({
  title,
  details,
  actions,
  expanded,
  handleChange,
  isExpandable,
  isHidden,
  discription = false,
  error,
}) => {
  if (isHidden) {
    return null;
  }

  return (
    <S.MyAccordion error={error?.toString()} expanded={expanded || false} onChange={handleChange}>
      <S.MyAccordionSummary
        expandIcon={isExpandable && <S.StyledExpandMoreIcon className='expandIcon' />}
        aria-controls='application-content'
        id='application-header'
      >
        <h2 className='sectionName' style={labelStyle}>
          {title}
        </h2>
        {discription && !expanded && <p style={discStyle}>{discription}</p>}
      </S.MyAccordionSummary>
      <AccordionDetails>{details}</AccordionDetails>
      <>{actions}</>
    </S.MyAccordion>
  );
};

export default CampaignSection;
